var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadLog = function SvgUploadLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9L8 8.99998C7.44771 8.99998 7 8.55226 7 7.99998C7 7.44769 7.44772 6.99998 8 6.99998L24 7C24.5523 7 25 7.44771 25 8C25 8.55228 24.5523 9 24 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3536 11.3536C16.1583 11.1583 15.8417 11.1583 15.6464 11.3536L9.85355 17.1464C9.53857 17.4614 9.76165 18 10.2071 18H13.5L13.5 25.5C13.5 25.7761 13.7239 26 14 26H18C18.2761 26 18.5 25.7761 18.5 25.5V18L21.7929 18C22.2383 18 22.4614 17.4614 22.1464 17.1464L16.3536 11.3536Z",
    fill: "currentColor"
  })));
};
export default SvgUploadLog;